import "Content/icons.css";
import "Content/theme.core.less";
import "devexpress-richedit/dist/dx.richedit.css";
import "devextreme/dist/css/dx.light.css";
import "ol/ol.css";
import "system-font-css";
import "yfiles/yfiles.css";
import DxOverrides from "Components/theme/dxOverrides";
import theme from "Components/theme/themeVariables";
import YWorksOverrides from "Components/theme/yWorksOverrides";
import { localizeDevextreme } from "Common/dxLocalization";
import React from "react";
import { ThemeProvider } from "styled-components";
export default function AppStyledTemplate({ children }) {
    localizeDevextreme();
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(React.Fragment, null,
            React.createElement(DxOverrides, null),
            React.createElement(YWorksOverrides, null),
            children)));
}
